import { z } from 'zod';

export const publishSocialVideoV1RequestSchema = z.object({
  socialVideoId: z.number(),
  channelIds: z.array(z.number()),
  caption: z.string().optional(),
  title: z.string().optional(),
  firstComment: z.string().optional(),
});

export type IPublishSocialVideoV1Request = z.infer<typeof publishSocialVideoV1RequestSchema>;
